import coreAppService from '../_shared/api/coreAppService';
import transactionRouterService from '../_shared/api/transactionRouterService';
import ListAppService from '../_shared/api/listAppService';
import { paymentsOnHoldRequest } from '../_shared/types';
import Singleton from '../Singleton';
import {
  PaymentOnHoldSearchRequest,
  PaymentOnHoldSummaryRequest
} from '../global.d';

export default class ActivityService extends Singleton<ActivityService> {
  /**
   * Returns the summary of payments on hold
   */
  public getPaymentsOnHoldSummary = async (
    paymentOnHoldRequest: paymentsOnHoldRequest
  ) => {
    try {
      const client = await coreAppService();
      const paymentsOnHoldResponse = await client.paymentsOnHold.getPostSaleSummary(
        paymentOnHoldRequest,
        {}
      );
      return paymentsOnHoldResponse?.data;
    } catch (e) {
      return null;
    }
  };

  /**
   * Returns the metadata for payments on hold
   */
  public getPaymentsOnHoldMetadata = async () => {
    try {
      const client = await coreAppService();
      const paymentsOnHoldResponse = await client.paymentsOnHold.getPaymentsOnHoldMetadata();
      return paymentsOnHoldResponse?.data;
    } catch (e) {
      return null;
    }
  };

  /**
   * Returns the metadata for payments on hold
   */
  public getPaymentsOnHoldTradeList = async requestBody => {
    try {
      const client = await ListAppService();
      const paymentsOnHoldResponse = await client.trade.getPostSaleTradeList(
        requestBody,
        {}
      );
      return paymentsOnHoldResponse?.data;
    } catch (e) {
      return null;
    }
  };

  /**
   * Returns the ETR summary of payments on hold
   */
  public getEtrPaymentsOnHoldSummary = async (
    paymentOnHoldSummaryRequest: PaymentOnHoldSummaryRequest
  ) => {
    try {
      const client = await transactionRouterService();
      const response = await client.api.paymentOnHoldSummaryList(
        paymentOnHoldSummaryRequest,
        {}
      );

      return response.data;
    } catch (e) {
      return null;
    }
  };

  /**
   * Returns the ETR payments on hold
   */
  public getEtrPaymentsOnHoldSearchList = async (
    paymentOnHoldSearchRequest: PaymentOnHoldSearchRequest
  ) => {
    try {
      const client = await transactionRouterService();
      const response = await client.api.paymentOnHoldSearchList(
        paymentOnHoldSearchRequest,
        {}
      );

      return response.data;
    } catch (e) {
      return null;
    }
  };
}
